export const getAuthStatus = (state) => state.authentication.status;
export const getActivitySessionStatus = (state) => state.activitySession.status;
